import { useState, useEffect, useRef } from "react"

const useTabControl = () => {
  const [activeIndex, setActiveIndex] = useState(0)
  const titlesRef = useRef([])
  const panelsRef = useRef([])

  useEffect(() => {
    const handleClick = (event) => {
      const selectedItem = event.target.closest("[data-item]")
      if (!selectedItem) return

      const index = titlesRef.current.indexOf(selectedItem)
      if (index !== -1) {
        setActiveIndex(index)
      }
    }

    const titlesHolder = document.querySelector("[data-tabs-container]")
    if (titlesHolder) {
      titlesHolder.addEventListener("click", handleClick)
    }

    return () => {
      if (titlesHolder) {
        titlesHolder.removeEventListener("click", handleClick)
      }
    }
  }, [])

  useEffect(() => {
    titlesRef.current.forEach((title, i) => {
      if (i === activeIndex) {
        title.classList.add("active")
        title.classList.remove("inactive")
      } else {
        title.classList.add("inactive")
        title.classList.remove("active")
      }
    })

    panelsRef.current.forEach((panel, i) => {
      if (i === activeIndex) {
        panel.classList.add("active")
        panel.classList.remove("inactive")
      } else {
        panel.classList.add("inactive")
        panel.classList.remove("active")
      }
    })
  }, [activeIndex])

  const registerTitle = (element) => {
    if (element && !titlesRef.current.includes(element)) {
      titlesRef.current.push(element)
    }
  }

  const registerPanel = (element) => {
    if (element && !panelsRef.current.includes(element)) {
      panelsRef.current.push(element)
    }
  }

  return {
    registerTitle,
    registerPanel,
  }
}

export default useTabControl
